// ChangelogPage.jsx
import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { Container } from "react-bootstrap";

// Style Constants
const headerStyle = {
  textAlign: "center",
  fontSize: "56px",
  marginTop: "1%",
};

const featureBoxStyle = {
  backgroundColor: "white",
  border: "2px solid black",
  padding: "10px",
  marginBottom: "20px",
};

const improvementBoxStyle = {
  backgroundColor: "white",
  border: "2px solid black",
  padding: "10px",
  marginBottom: "20px",
};

const listStyle = {
  listStyleType: "disc",
  paddingLeft: "20px",
  lineHeight: "2em",
};

const ChangelogPage = () => (
  <Container style={{ marginTop: "7%" }}>
    <br />
    <br />
    <br />
    <p style={headerStyle}>Change log</p>

    <VerticalTimeline layout={"2-columns"}>
      {/* 🔹 Version 4.9 - October 17th, 2025 */}
      <VerticalTimelineElement
        className="vertical-timeline-element--update"
        contentArrowStyle={{ borderRight: "7px solid  #18202F" }}
        date={
          <>
            October 17<sup>th</sup>, 2025
          </>
        }
        iconStyle={{
          background: "#18202F",
          color: "#fff",
        }}
      >
        <h3 className="vertical-timeline-element-title">
          Version 4.9 - Feature Update
        </h3>

        <div style={featureBoxStyle}>
          <h4>Added Features</h4>
          <ul style={listStyle}>
            <li>
              Existing adaptation integrated for:
              <ul style={listStyle}>
                <li>River Flood</li>
                <li>Wildfire</li>
                <li>Drought</li>
                <li>Rainfall Flood (coming soon)</li>
              </ul>
            </li>
            <li>
              Urban Heat Index integrated in Extreme Heat maps as a service –
              Wildfire Probability
            </li>
            <li>Building age integration (automated and tailored options)</li>
          </ul>
        </div>

        <div style={improvementBoxStyle}>
          <h4>Improvements</h4>
          <ul style={listStyle}>
            <li>
              Improved granularity for Wildfire:
              <ul style={listStyle}>
                <li>
                  India, Nepal, Sri Lanka, Indonesia, China, Vietnam, Thailand,
                  Laos, Cambodia – 100m
                </li>
              </ul>
            </li>
            <li>
              Improved granularity for Rainfall Flood:
              <ul style={listStyle}>
                <li>Laos, Taiwan – 30m</li>
              </ul>
            </li>
            <li>UI/UX enhancements across the platform</li>
          </ul>
        </div>
      </VerticalTimelineElement>

      {/* Existing Version 4.8 */}
      <VerticalTimelineElement
        className="vertical-timeline-element--update"
        contentArrowStyle={{ borderRight: "7px solid  #18202F" }}
        date={
          <>
            August 27<sup>th</sup>, 2025
          </>
        }
        iconStyle={{
          background: "#18202F",
          color: "#fff",
        }}
      >
        <h3 className="vertical-timeline-element-title">
          Version 4.8 - Feature Update
        </h3>

        <div style={featureBoxStyle}>
          <h4>Added Features</h4>
          <ul style={listStyle}>
            <li>
              New columns added in asset table and bulk edit functionality
            </li>
            <li>Heatmap now shows average of assets and hazards</li>
            <li>Multi-step process UI for creating portfolios</li>
            <li>Global building height data integrated</li>
            <li>New building footprints added for China</li>
            <li>Two-Factor Authentication (2FA) enabled</li>
          </ul>
        </div>

        <div style={improvementBoxStyle}>
          <h4>Improvements</h4>
          <ul style={listStyle}>
            <li>
              Improved granularity for Wildfire
              <ul style={listStyle}>
                <li>Australia, Japan, Korea – 100m</li>
              </ul>
            </li>
            <li>
              Improved granularity for Rainfall Flood
              <ul style={listStyle}>
                <li>Germany, South Africa, Australia – 30m</li>
              </ul>
            </li>
            <li>
              Improved granularity for Storm Surge
              <ul style={listStyle}>
                <li>Australia, Hong Kong – 0.5m</li>
              </ul>
            </li>
            <li>Complete UI/UX enhancements across the platform</li>
          </ul>
        </div>
      </VerticalTimelineElement>

      {/* Other Versions remain unchanged */}
      <VerticalTimelineElement
        className="vertical-timeline-element--update"
        contentArrowStyle={{ borderRight: "7px solid  #18202F" }}
        date={
          <>
            April 16<sup>th</sup>, 2025
          </>
        }
        iconStyle={{
          background: "#18202F",
          color: "#fff",
        }}
      >
        <h3 className="vertical-timeline-element-title">
          Version 4.75 - Feature Update
        </h3>

        <div style={featureBoxStyle}>
          <h4>Added Features</h4>
          <ul style={listStyle}>
            <li>
              Residual Climate Value at Risk enables simulations and integration
              of existing or planned adaptation and mitigation measures at asset
              and surrounding levels
            </li>
            <li>
              Total Asset Value Combined valuation, operational, and inventory
              exposure of all assets (expressed in dollar terms)
            </li>
            <li>Inventory Value now accepted as an input via CSV</li>
          </ul>
        </div>

        <div style={improvementBoxStyle}>
          <h4>Improvements</h4>
          <ul style={listStyle}>
            <li>Storm Surge maps refined for 1:100 and 1:250 return periods</li>
            <li>
              Improved granularity for Rainfall Flood
              <ul style={listStyle}>
                <li>Italy – 30m resolution</li>
              </ul>
            </li>
            <li>
              Content Value now included in both Maximum Exposure and Total
              Asset Value calculations
            </li>
            <li>UI/UX Enhancements across dashboard and selection flows</li>
          </ul>
        </div>
      </VerticalTimelineElement>

      {/* Version 4.5 */}
      <VerticalTimelineElement
        className="vertical-timeline-element--update"
        contentArrowStyle={{ borderRight: "7px solid  #18202F" }}
        date={
          <>
            January 27<sup>th</sup>, 2025
          </>
        }
        iconStyle={{
          background: "#18202F",
          color: "#fff",
        }}
      >
        <h3 className="vertical-timeline-element-title">
          Version 4.5 - Feature Update
        </h3>

        <div style={featureBoxStyle}>
          <h4>Added Features</h4>
          <ul style={listStyle}>
            <li>New Variables: Extreme Cold and Snowfall</li>
            <li>Bounding Box-Based Location Selection in Maps</li>
            <li>Plinth Height Inputs and Calculations</li>

            <li>
              Gross Area, Total Valuation, and Total Content Value in Upload CSV
            </li>
          </ul>
        </div>

        {/* Hazard Modelling and Outputs Section */}
        <div style={improvementBoxStyle}>
          <h4>Improvements</h4>
          <ul style={listStyle}>
            <li>
              New Wildfire: Enhanced resolution to 30m with additional input
              variables
            </li>
            <li>Improved granularity for Rainfall Flood</li>
            <ul style={listStyle}>
              <li>Malaysia, Singapore, Mongolia, Turkey - 30m</li>
              <li>Eastern Coast of Australia – 5m</li>
              <li>London, UK – 2m</li>
            </ul>
            <li>
              New Global Storm Surge model with Delta-DEM (100-year Return
              period)
            </li>
            <li>
              Extreme Cold: Predicted minimum temperature from CMIP6 datasets
            </li>
            <li>Snowfall: Annual snowfall in mm/year</li>
            <li>Extreme Heat: Updated to 1km resolution</li>
          </ul>
        </div>

        {/* User Interface and Experience Section */}
      </VerticalTimelineElement>

      {/* Other Versions */}
      {/* Add Version 4.0 and Version 3.0 as needed (existing code structure) */}

      <VerticalTimelineElement
        className="vertical-timeline-element--update"
        contentArrowStyle={{ borderRight: "7px solid  #18202F" }}
        date="October 2024"
        iconStyle={{
          background: "#18202F",
          color: "#fff",
        }}
      >
        <h3 className="vertical-timeline-element-title">
          Version 4.0 - Feature Update
        </h3>

        {/* Added Features Section */}
        <div style={featureBoxStyle}>
          <h4>Added Features</h4>
          <ul style={listStyle}>
            <li>Map Module (Version 1.0)</li>
            <ul style={listStyle}>
              <li>Global coverage</li>
              <li>Create maps from 1km to 50 km</li>
              <li>Rainfall data and Storm surge data are available</li>
            </ul>
            <li>PDF reports (Version 1.0)</li>
            <ul style={listStyle}>
              <li>Generate report automatically</li>
            </ul>
          </ul>
        </div>

        {/* Improvements Section */}
        <div style={improvementBoxStyle}>
          <h4>Improvements</h4>
          <ul style={listStyle}>
            <li>Rainfall Flood</li>
            <ul style={listStyle}>
              <li>Houston - 1m</li>
              <li>New York - 1m</li>
              <li>Los Angeles - 1m</li>
            </ul>
            <li>Storm Surge Delta DEM</li>
            <ul style={listStyle}>
              <li>30m Globally</li>
            </ul>
            <li>SSP 5-year interval on dashboard</li>
            <li>Input CSV</li>
            <ul style={listStyle}>
              <li>
                Total inputs (gross area, total valuation, total content value)
                in input CSV
              </li>
            </ul>
          </ul>
        </div>
      </VerticalTimelineElement>
      {/* Version 3.0 */}
      <VerticalTimelineElement
        className="vertical-timeline-element--update"
        contentArrowStyle={{ borderRight: "7px solid  #18202F" }}
        date="May 2024"
        iconStyle={{
          background: "#18202F",
          color: "#fff",
        }}
      >
        <h3 className="vertical-timeline-element-title">
          Version 3.0 - Feature Update
        </h3>
        {/* Added Features Section */}
        <div style={featureBoxStyle}>
          <h4>Added Features</h4>
          <ul style={listStyle}>
            <li>Updated user interface</li>
            <li>Building level flood adaptation (Mitigation)</li>
            <li>Allows three (3) different levels of flood mitigation</li>
            <li>Integrated into both Hazard and Financial analysis</li>
            <li>Applicable for Rainfall and River Flood</li>
            <li>
              Building footprint database generated covering 1.3 billion
              buildings globally integrating Microsoft, Google, and HK footprint
              data
            </li>
            <li>
              New damage functions specific to asset types (infrastructure) and
              regions
            </li>
            <li>Ability to add basement as an asset-level variable</li>
            <li>Ability to share projects within an organization</li>
          </ul>
        </div>

        {/* Improvements Section */}
        <div style={improvementBoxStyle}>
          <h4>Improvements</h4>
          <ul style={listStyle}>
            <li>
              Enhancements to calculation of business interruption days for
              Floods and Typhoons
            </li>
          </ul>

          <h4>Hazard Resolution</h4>
          <ul style={listStyle}>
            <li>Storm Surge</li>
            <ul style={listStyle}>
              <li>30m Globally (FABDEM)</li>
            </ul>
            <li>Rainfall Flood</li>
            <ul style={listStyle}>
              <li>Malaysia, Singapore, Mongolia, Turkey - 30m</li>
              <li>Eastern Coast of Australia – 5m</li>
              <li>London, UK – 2m</li>
            </ul>
          </ul>
        </div>
      </VerticalTimelineElement>

      {/* ... rest of your changelog entries (4.5, 4.0, 3.0, etc.) remain unchanged ... */}
    </VerticalTimeline>
  </Container>
);

export default ChangelogPage;
